export default [
  {
    "x": 148.000123,
    "y": 155.9351,
    "angle": 1.597695239666933,
    "lengthA": 4.052697079151243,
    "lengthB": 7.095400801255145
  },
  {
    "x": 160.850123,
    "y": 143.0851,
    "angle": 3.141592653589793,
    "lengthA": 7.097000000000008,
    "lengthB": 8.067466999999994
  },
  {
    "x": 188.080123,
    "y": 143.0851,
    "angle": 2.5269570758646096,
    "lengthA": 3.8148229809238696,
    "lengthB": 10.395695867093103
  },
  {
    "x": 198.034123,
    "y": 116.8391,
    "angle": -3.1386803652590762,
    "lengthA": 9.954042212193052,
    "lengthB": 9.954042212193052
  },
  {
    "x": 218.780123,
    "y": 116.8951,
    "angle": -3.1392160297343894,
    "lengthA": 6.683015873967232,
    "lengthB": 11.86803351537334
  },
  {
    "x": 228.670123,
    "y": 168.7221,
    "angle": -2.732562536723586,
    "lengthA": 3.5215208326068543,
    "lengthB": 4.880973184110938
  },
  {
    "x": 255.891123,
    "y": 114.6171,
    "angle": 3.141592653589793,
    "lengthA": 11.268135000000001,
    "lengthB": 14.061437000000012
  },
  {
    "x": 237.11607,
    "y": 239.41198,
    "angle": -1.140354754955084,
    "lengthA": 4.740311734101872,
    "lengthB": 4.740312642883484
  },
  {
    "x": 191.111123,
    "y": 243.8781,
    "angle": 0.8356861983559196,
    "lengthA": 6.0843559541263765,
    "lengthB": 6.084355954126354
  },
  {
    "x": 186.937119,
    "y": 196.948596,
    "angle": 2.087146459493739,
    "lengthA": 12.507067658717514,
    "lengthB": 12.507068528344487
  },
  {
    "x": 211.180618,
    "y": 176.617407,
    "angle": 1.5707963267948966,
    "lengthA": 9.464253000000014,
    "lengthB": 23.18777399999999
  }
]